import { MILL_1 } from "@/setup/mill-config/mill-config";
import { getMomentTz, MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { EventYear } from "../models/EventYear";

const moment = getMomentTz();

export const getCalendarYear = async (
	params: {
		year: number;
		isDraftMode: boolean;
		onlyProduction: boolean;
		defaultAreaId?: string | number | null;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "Year", value: params.year },
		{ name: "DraftMode", value: params.isDraftMode },
		{ name: "OnlyProduction", value: params.onlyProduction },
	];

	const resp = await apiService.callV2(
		Number(params.defaultAreaId) === MILL_1.id
			? "[M1].[GetCalendarYear]"
			: "[M2].[GetCalendarYear]",
		parameters,
		signal,
	);

	if (resp.ok) {
		let rows = get(resp, "data.tables[0].rows", []) as EventYear[];
		rows = rows.map((e: EventYear) => ({
			...e,
			Start: moment.utc(e["Start"]).toDate(),
			End: moment.utc(e["End"]).toDate(),
		}));

		return rows as EventYear[];
	} else {
		throw new Error(resp.message ?? "Error loading year calendar");
	}
};
